export const conversationContactId = conversation => {
  if (!conversation || typeof conversation !== 'object') return null;
  const fromRoot = conversation.contact_id;
  const fromMeta = conversation.meta?.sender?.id;
  if (fromRoot != null && fromRoot !== '') {
    const id = Number(fromRoot);
    return Number.isFinite(id) ? id : null;
  }
  if (fromMeta != null && fromMeta !== '') {
    const id = Number(fromMeta);
    return Number.isFinite(id) ? id : null;
  }
  return null;
};

export const findSameContactInList = (list, openConversation, openId) => {
  const contactId = conversationContactId(openConversation);
  if (!contactId || !Array.isArray(list) || !list.length) return null;
  return (
    list.find(
      chat =>
        Number(chat.id) !== Number(openId) &&
        conversationContactId(chat) === contactId
    ) || null
  );
};
